import { InjectionToken } from '@angular/core';

export const PlatformSyncToken = new InjectionToken('PlatformSyncToken');

export interface IPlatformSync {
  canBeSynced: boolean;
  isCordova: boolean;
  ready: Promise<void>;
}
